import React from 'react';

export default function MarketOpportunity() {
  return (
    <section className="w-full bg-gray-950 text-white py-20 px-6 md:px-10">
      <div className="max-w-6xl mx-auto space-y-14">

        {/* Section Title */}
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">The Market Opportunity</h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            M2T is targeting a massive, underserved segment: verified financial professionals across emerging and mature markets.
          </p>
        </div>

        {/* TAM / SAM / SOM Breakdown */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center text-gray-300 text-base">

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl font-semibold text-white mb-2">🌐 TAM</h3>
            <p className="text-sm">
              500M+ global market professionals across trading, investing, research, education, analytics, and advisory.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl font-semibold text-white mb-2">🎯 SAM</h3>
            <p className="text-sm">
              30M+ active individuals seeking to earn via services, courses, signals, or investor access in 24+ countries.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl font-semibold text-white mb-2">🏆 SOM</h3>
            <p className="text-sm">
              3–5M early users through role-based activation: verified traders, mentors, brokers, and analysts in top 12 markets.
            </p>
          </div>

        </div>

        {/* Comparables Block */}
        <div className="text-center space-y-6">
          <p className="text-lg text-gray-300">
            M2T combines the best of:
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-6 text-white font-semibold text-xl">
            <div className="bg-gray-800 rounded-lg py-3 px-6">LinkedIn</div>
            <div className="bg-gray-800 rounded-lg py-3 px-6">TradingView</div>
            <div className="bg-gray-800 rounded-lg py-3 px-6">Upwork</div>
          </div>
          <p className="text-gray-400 text-sm max-w-xl mx-auto pt-4">
            We’re not competing with these platforms — we’re unifying what they can’t. One identity. One dashboard. Multiple revenue layers.
          </p>
        </div>

      </div>
    </section>
  );
}
